import { combineReducers } from 'redux';

import account from './accountReducer';
import appointments from './appointmentsReducer';
import alertDialog from './alertDialogReducer';
import auditLog from './auditLogReducer';
import authenticatedPreferences from './authenticatedPreferencesReducer';
import confirmDialog from './confirmDialogReducer';
import loadingState from './loadingStateReducer';
import forms from './formsReducer';
import familyAccess from './familyAccessReducer';
import fullPageLoadingState from './fullPageLoadingStateReducer';
import header from './headerReducer';
import health from './healthReducer';
import locations from './locationsReducer';
import links from './linksReducer';
import mainMenu from './mainMenuReducer';
import medications from './medicationReducer';
import messages from './messagesReducer';
import metadata from './metadataReducer';
import notifications from './notificationsReducer';
import preferences from './preferencesReducer';
import profile from './profileReducer';
import publicState from './publicReducer';
import user from './userReducer';
import waitlist from './waitlistReducer';


const appReducer = combineReducers({
  account,
  appointments,
  alertDialog,
  auditLog,
  authenticatedPreferences,
  confirmDialog,
  familyAccess,
  forms,
  fullPageLoadingState,
  links,
  loadingState,
  header,
  health,
  locations,
  mainMenu,
  medications,
  messages,
  metadata,
  notifications,
  preferences,
  profile,
  publicState,
  user,
  waitlist,
});

// Understand why we wipe state on logout
// https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
const rootReducer = (state, action) => {
 if (action.type === 'LOGOUT_REQUEST') {
   state = undefined;
 }

 return appReducer(state, action)
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js